import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

export default function DropDown() {
  const { t: tGC } = useTranslation([], { keyPrefix: 'team.Global.Common' });
  const { t: tGT } = useTranslation([], { keyPrefix: 'team.Global.Tables' });
  const { t: tCO } = useTranslation([], {
    keyPrefix: 'team.Components.PackingSlipsBrowseTable',
  });

  const [searchBy, setSearchBy] = React.useState('companyName');

  const handleChange = (event: SelectChangeEvent) => {
    setSearchBy(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">
          {tGT('Search By')}
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={searchBy}
          label={tGT('Search By')}
          onChange={handleChange}
        >
          <MenuItem value={'companyName'}>{tGC('Customer')}</MenuItem>
          <MenuItem value={'customerCode'}>{tCO('Customer Code')}</MenuItem>
          <MenuItem value={'code'}>{tCO('Packing Slip No.')}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
